// GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
  &::-webkit-scrollbar {
    width: 14px; /* 스크롤바의 너비 */
    height: 14px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.white1};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.white4};
    border-radius: 12px; /* 스크롤바의 모서리 반경 */
    border: 4px solid ${props => props.theme.white1};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.white5};
  }
  }
  *::selection {
    border-radius: 10%;
    background: ${props => props.theme.opacityblue1};
  }
  p {
    margin: 0;
  }

  html, body {
    height: 100%;
    color: ${props => props.theme.black1};
    background-color: ${props => props.theme.white0};
    font-family: "Noto Sans KR", sans-serif;
    font-weight: 400;
    font-size: 14px;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  @font-face {
    font-family: 'NanumBarunpen';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_two@1.0/NanumBarunpen.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'ChosunGu';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@1.0/ChosunGu.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Freesentation-9Black';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/2404@1.0/Freesentation-9Black.woff2') format('woff2');
    font-weight: 900;
    font-style: normal;
  }
  @font-face {
    font-family: 'Atomy-Bold';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_four@1.0/Atomy-Bold.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Pretendard-Regular';
    src: url('https://fastly.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }
`;

export default GlobalStyles;
